import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { LogInComponent } from "../LogInComponent";
import * as PortalManagement from "../PortalManagement";
import { AppStore } from "../Stores/AppStore";
import { DialogStore } from "../Stores/DialogStore";
import { NotificationStore } from "../Stores/NotificationStore";
import { Strings } from "../Stores/StringsStore";

@observer
export class SyncStatus extends React.Component<{}, {}> {

	refreshInterval: number = 15;

	componentDidMount() {
		this.GetConnectedStatus();
		setInterval(() => {
			this.GetConnectedStatus();
		}, this.refreshInterval * 1000)
	}

	GetConnectedStatus = () => {
		NotificationStore.clearMessage();
		PortalManagement.getIsConnectedAsync().then(result => {
			console.log("API Sync - " + new Date() + " - " + result);
			if (result) {
				AppStore.isSystemOnline = true;
			}
			else {
				AppStore.isSystemOnline = false;
			}
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
			AppStore.isSystemOnline = false;
		});
	}

	@computed get statusCSS() {
		return AppStore.isSystemOnline ? "syncstatus" : "app__head-status syncstatus";
	}

	render() {
		return <div className={this.statusCSS}>
			{
				AppStore.isSystemOnline
					? AppStore.context.sessionDetails.isAppRegistrationEnabled ? <div id="script-wrapper"></div> : <LogInComponent testId="logInButton" />
					: <button className="button is--button-status" disabled>
						<span>OFF</span>
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
								<g>
									<path d="M24.14,4.34a8,8,0,0,0-11.31,0L11.41,5.76l2.12,2.12,1.41-1.41A5,5,0,0,1,22,13.54l-1.41,1.41,2.12,2.12,1.41-1.41A8,8,0,0,0,24.14,4.34Z" />
									<path d="M4.34,24.14a8,8,0,0,0,11.31,0l1.41-1.41-2.12-2.12L13.54,22a5,5,0,0,1-7.07-7.07l1.41-1.41L5.76,11.41,4.34,12.83A8,8,0,0,0,4.34,24.14Z" />
								</g>
							</svg>
						</i>
					</button>
			}
		</div>;
	}
}
